var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFilledLightning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.55403 16C7.47138 16 7.388 15.9855 7.30607 15.9556C6.99286 15.8415 6.7971 15.5273 6.83335 15.1949L7.39018 10.0364H3.12337C2.85584 10.0364 2.61005 9.88878 2.4839 9.65169C2.35774 9.4146 2.37224 9.12806 2.52087 8.90479L8.23991 0.323039C8.42552 0.0444955 8.77643 -0.07114 9.09037 0.0444954C9.40431 0.158676 9.59934 0.472856 9.56309 0.805216L9.00627 5.96372H13.2738C13.5413 5.96372 13.7871 6.11135 13.9133 6.34844C14.0387 6.58553 14.0249 6.87208 13.8763 7.09535L8.15653 15.6771C8.0195 15.8836 7.79039 16 7.55403 16Z",
    fill: "#FFC400"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilledLightning);
export default __webpack_public_path__ + "static/media/icon-filled-lightning.f036dd853708715c8652c85559df05e7.svg";
export { ForwardRef as ReactComponent };